import dynamic from 'next/dynamic';

import { getLazyHydrateTools } from '@/core/lazyHydrate/lazyHydrateTool';
import { MenuForSEOProps } from '@/productDiscovery/HeaderLeonidas/components/Menu/MenuForSEO';

const { dynamicOptions, makeLazyHydrated } =
  getLazyHydrateTools<MenuForSEOProps>({
    id: 'header.MenuForSEO',
    on: 'never',
    placeholder: <nav className="hidden" />,
  });

const DynamicMenuForSEO = dynamic<MenuForSEOProps>(
  async () =>
    (
      await import(
        '@/productDiscovery/HeaderLeonidas/components/Menu/MenuForSEO'
      )
    ).MenuForSEO,
  { ...dynamicOptions },
);

export const MenuForSEO = makeLazyHydrated(DynamicMenuForSEO);
